import { render, staticRenderFns } from "./Inscription.vue?vue&type=template&id=65a39702&scoped=true&"
import script from "./Inscription.vue?vue&type=script&lang=js&"
export * from "./Inscription.vue?vue&type=script&lang=js&"
import style0 from "./Inscription.vue?vue&type=style&index=0&id=65a39702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a39702",
  null
  
)

export default component.exports